/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

function startOnSecondProduct(){
  if(window.innerWidth>749)return;

  document.querySelectorAll(
    '[data-section-id="template--30145730838876__section_collection_rLrqKD"] items-scroll-paged-navigation,[data-section-id="template--30145730838876__section_collection_rMFedX"] tab-panel:not([hidden]):not([aria-hidden="true"]) items-scroll-paged-navigation'
  ).forEach(function(carousel){
    var track=carousel.querySelector("[data-items]");
    var cards=track&&track.querySelectorAll(".product-card");

    if(track&&cards&&cards[1]){
      track.scrollLeft=cards[1].offsetLeft;
    }
  });
}

function runSecondProduct(){
  setTimeout(startOnSecondProduct,100);
  setTimeout(startOnSecondProduct,700);
  setTimeout(startOnSecondProduct,1500);
}

document.addEventListener("DOMContentLoaded",runSecondProduct);
window.addEventListener("load",runSecondProduct);
document.addEventListener("shopify:section:load",runSecondProduct);

document.addEventListener("click",function(event){
  if(event.target.closest(
    '[data-section-id="template--30145730838876__section_collection_rMFedX"] [role="tab"],[data-section-id="template--30145730838876__section_collection_rMFedX"] [aria-controls^="tab-collection_"],[data-section-id="template--30145730838876__section_collection_rMFedX"] .tab-triggers *'
  )){
    runSecondProduct();
  }
});








